import { jsxs as $, jsx as a } from "react/jsx-runtime";
import { forwardRef as N, useContext as g, useMemo as j } from "react";
import { ChartAxisContext as w } from "./chart-axis.js";
import { Tooltip as A } from "../../tooltip/tooltip.js";
import { useValues as B, useTooltip as T } from "./chart-utils.js";
import d from "../chart.module.css.js";
import y from "clsx/lite";
const E = N(
  function({ children: t, className: o, shade: n, smooth: s = 10, ...r }, c) {
    const { total: i, direction: p } = g(w), [h, M] = B(c), l = p === "vertical", P = y(d.lineContainer, o), m = j(() => {
      if (!i || !h.length) return "";
      const R = h.map(({ value: u }, f, { length: v }) => [
        l ? u / i * 100 : 100 / (v - 1) * f,
        l ? 100 / (v - 1) * f : 100 - u / i * 100
      ]);
      return X(R, s / 100);
    }, [s, i, h, l]);
    return /* @__PURE__ */ $("div", { className: P, "data-value": !0, role: "list", ref: M, ...r, children: [
      /* @__PURE__ */ $(
        "svg",
        {
          "aria-hidden": "true",
          preserveAspectRatio: "none",
          viewBox: "0 0 100 100",
          children: [
            /* @__PURE__ */ a("path", { className: d.lineBorder, d: m }),
            /* @__PURE__ */ a("path", { className: d.line, d: m })
          ]
        }
      ),
      !!n && !!m && // Render shade path in separate <svg> to achieve different z-indexes
      /* @__PURE__ */ a(
        "svg",
        {
          "aria-hidden": "true",
          preserveAspectRatio: "none",
          viewBox: "0 0 100 100",
          children: /* @__PURE__ */ a(
            "path",
            {
              d: `${l ? "M0,-100 L" : "M-100,100 L"}${m.slice(1)}${l ? "L0,200" : "L200,100"}`,
              className: d.lineShade,
              style: r.style
            }
          )
        }
      ),
      t
    ] });
  }
), F = N(
  function({ className: t, tooltip: o, style: n, value: s, ...r }, c) {
    return /* @__PURE__ */ a("div", { role: "listitem", children: /* @__PURE__ */ a(
      A,
      {
        as: "div",
        className: y(d.linePoint, t),
        "data-legend": "inherit",
        "data-value": s,
        style: { ...n, "--value": s },
        ref: c,
        ...T(o, s),
        ...r
      }
    ) });
  }
), X = (e, t) => e.map(([o, n], s, r) => s ? Y(s, r, t) : `M${o},${n}`).join(" "), C = ([e, t], [o, n]) => [e + o, t + n], x = ([e, t], [o, n]) => [e - o, t - n], L = (e, [t, o]) => [e * t, e * o], Y = (e, t, o) => {
  const n = t[e - 1], s = t[e], [r, c] = C(n, L(o, x(s, t[e - 2] || n))), [i, p] = C(s, L(o, x(n, t[e + 1] || s)));
  return `C ${r},${c} ${i},${p} ${s[0]},${s[1]}`;
};
export {
  E as ChartLine,
  F as ChartLinePoint
};
//# sourceMappingURL=chart-line.js.map
